module.exports = __webpack_public_path__ + "media/images/warning-173c2a8fb5544b5f04fbd27b23e18a51.svg";